import Axios from 'axios'
import Moment from 'moment'

import { getCockpitLink } from 'utils/getCockpitLink'

import {
  beginAjaxCall,
  ajaxCallError,
  ajaxCallSuccess
} from './ajax';
import { storeItem } from 'utils/tokenStore';
import { getCipherHeader } from 'utils/cipher-text'
import getDomainURL from 'utils/api'
import Lang from 'Lang/General'

export function login({ email, password, platform, accountLockIntervalId, onChangeAccountLockIntervalId }) {
  return ( dispatch ) => {
    dispatch( beginAjaxCall( false ) );
    Axios.post(
      `${ getDomainURL() }/login`,
      {
        email,
        password,
        platform,
        cockpit_link: getCockpitLink()
      },
      {
        headers: {
          'Authorization': getCipherHeader(),
          'Accept-Language': 'de'
        }
      }
    ).then( response => {
      let AUTH_TOKEN = response.data.token;
      storeItem( 'PROOFPOINT_ARK_MANAGEMENT', AUTH_TOKEN );
      dispatch( ajaxCallSuccess( 'Login Success!' ) );
    }).catch( error => {
      if( error && error.response ) {
        if( error.response.data.Errors ) {
          let tmp = ''
          if ( typeof error.response.data.Errors === 'string' ) {
            tmp = error.response.data.Errors
            dispatch( ajaxCallError( tmp ) )
          } else {
            Object.values( 
              error.response.data.Errors 
            ).map( errorMsg => {
              accountLockIntervalId > 0 && clearInterval( accountLockIntervalId )
              tmp += typeof error.response.data?.locked_until !== 'undefined'
                ? errorMsg 
                : `${ errorMsg }. `                
              if( error.response.data?.locked_until && !error.response.data.is_permanent ){
                let tmpIntervalId = setInterval( () => {
                  let timeDifference = Moment( error.response.data.locked_until ).valueOf() - Moment().valueOf()
                  let duration = Moment.duration( timeDifference , 'milliseconds' )

                  if ( duration.asSeconds() >= 1 ) {
                    let tmpMsg = Lang[ 'YOUR_ACCOUNT_HAS_BEEN_LOCKED_FOR' ][ 'de' ]
                    tmpMsg = tmpMsg.replace( '${minutes}', duration.minutes() ).replace( '${seconds}', duration.seconds() ).replace( '${minutes_ceil}', duration.minutes() + 1 )
                    dispatch( ajaxCallError( tmpMsg ) )
                  } else {
                    dispatch( ajaxCallError( '' ) )
                  }
                }, 500 )

                onChangeAccountLockIntervalId( tmpIntervalId )
              } else {
                dispatch( ajaxCallError( tmp ) )
                onChangeAccountLockIntervalId( 0 )
              }
            })
          }
        } else {
          dispatch( ajaxCallError( error.response.data.Error ) )
        }
      } else {
        dispatch( ajaxCallError( 'Disconnected from internet, please connect to the internet and retry again.' ) );
      }
    });
  };
}
